
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import ContentPageRepository from '@/repositories/content/ContentPageRepository';
import EmbeddedForm from '@/util/form/EmbeddedForm';
import ContentPageTranslationRepository from '@/repositories/content/ContentPageTranslationRepository';
import RowTranslationRepository from '@/repositories/content/row/RowTranslationRepository';
import RowRepository from '@/repositories/content/row/RowRepository';
import RowPageRepository from '@/repositories/content/row/RowPageRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class ContentPageFormScreen extends Vue {
    @Inject()
    private readonly contentPageRepository!: ContentPageRepository;

    @Inject()
    private readonly contentPageTranslationRepository!: ContentPageTranslationRepository;

    @Inject()
    private readonly rowRepository!: RowRepository;

    @Inject()
    private readonly rowTranslationRepository!: RowTranslationRepository;

    @Inject()
    private readonly rowPageRepository!: RowPageRepository;

    private get embeds(): EmbeddedForm[] {
        return [
            {
                relationship: 'translations',
                parentRefKey: 'pageId',
                i18nGroup: 'contentPageTranslation',
                entityRepository: this.contentPageTranslationRepository,
                columns: ['lang', 'title'],
            },
            {
                relationship: 'rows',
                parentRefKey: 'pageId',
                i18nGroup: 'row',
                entityRepository: this.rowRepository,
                columns: ['defaultContent', 'type'],
                embeds: [
                    {
                        relationship: 'translations',
                        parentRefKey: 'rowId',
                        i18nGroup: 'rowTranslation',
                        entityRepository: this.rowTranslationRepository,
                        columns: ['lang', 'body'],
                    },
                    {
                        relationship: 'pages',
                        parentRefKey: 'rowId',
                        i18nGroup: 'rowPage',
                        entityRepository: this.rowPageRepository,
                        columns: ['pageName'],
                    },
                    {
                        relationship: 'order',
                        parentRefKey: 'rowId',
                        i18nGroup: 'row',
                        entityRepository: this.rowRepository,
                        columns: ['defaultContent', 'type'],
                    },
                ],
            },
            {
                relationship: 'order',
                parentRefKey: 'contentPageId',
                i18nGroup: 'contentPage',
                entityRepository: this.contentPageRepository,
                columns: ['defaultTitle'],
            },
        ];
    }
}
